import * as actions from './main.actions';
import { MainFilter, Client } from './main.models';
import { CountryStaticData, PageNotes, StaticData } from '../../global/interfaces';

export interface State {
  loading: boolean;
  clients: Client[];
  staticData: StaticData;
  countryWiseStaticData: CountryStaticData[];
  pageNotes: PageNotes;
  filter: MainFilter;
  country;
}

export const initialState: State = {
  loading: false,
  clients: [],
  countryWiseStaticData: [],
  staticData: {},
  pageNotes: {
    overview: {}, valuation: {}, performance: '', holdings: '', cashflow: '', taxDetails: '',
    transactions: '', statements: '', reports: {}, esg: {}
  },
  filter: {
    client: [],
    account: []
  },
  country: undefined
};

export function reducer(state: State = initialState, action: actions.Actions): State {
  switch (action.type) {
    case actions.ActionTypes.LOAD_MAIN_CLIENTS:
      return { ...state, loading: true };
    case actions.ActionTypes.LOAD_MAIN_CLIENTS_SUCCESS:
      return { ...state, loading: false, clients: action.payload };
    case actions.ActionTypes.LOAD_MAIN_CLIENTS_FAILED:
      return { ...state, loading: false, clients: [] };

    case actions.ActionTypes.SET_MAIN_FILTER:
      return { ...state, filter: action.payload };
    case actions.ActionTypes.SET_MAIN_FILTER_CLIENT:
      return { ...state, filter: { ...state.filter, client: action.payload } };
    case actions.ActionTypes.SET_MAIN_FILTER_ACCOUNT:
      return { ...state, filter: { ...state.filter, account: action.payload } };

    case actions.ActionTypes.LOAD_STATIC_DATA:
    case actions.ActionTypes.SET_STATIC_DATA:
      return { ...state, loading: true };
    case actions.ActionTypes.LOAD_STATIC_DATA_SUCCESS:
      return { ...state, loading: true, staticData: action.payload };
    case actions.ActionTypes.LOAD_STATIC_DATA_FAILED:
      return { ...state, loading: false, staticData: initialState.staticData };
    case actions.ActionTypes.SET_STATIC_DATA_SUCCESS:
      const data = {} as StaticData;
      action.payload.forEach(payload => {
        const key = payload.key as keyof StaticData;
        data[key] = payload.value;
      });

      return { ...state, loading: false, staticData: { ...state.staticData, ...data } };
    case actions.ActionTypes.SET_STATIC_DATA_FAILED:
      return { ...state, loading: false };

    case actions.ActionTypes.LOAD_PAGE_NOTES:
      return { ...state, loading: true };
    case actions.ActionTypes.LOAD_PAGE_NOTES_SUCCESS:
      return { ...state, pageNotes: action.payload, loading: false };
    case actions.ActionTypes.LOAD_PAGE_NOTES_FAILED:
      return { ...state, loading: false };

    case actions.ActionTypes.SET_SELECTED_COUNTRY:
      return { ...state, country: action.payload };


    case actions.ActionTypes.LOAD_LOG_IN_CONTACT_US:
      return { ...state, loading: true };
    case actions.ActionTypes.LOAD_LOG_IN_CONTACT_US_SUCCESS:
      return { ...state, countryWiseStaticData: action.payload, loading: false };
    case actions.ActionTypes.LOAD_LOG_IN_CONTACT_US_FAILED:
      return { ...state, loading: false };
    default:
      return state;
  }
}
